export default __webpack_public_path__ + "static/media/cemex.eb350eb4.png";